var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsCognito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 299,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 299",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m208.752 58.061 25.771-6.636.192.283.651 155.607-.843.846-5.31.227-20.159-3.138-.302-.794z",
    fill: "#7a3e65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59.705 218.971.095.007 68.027 19.767.173.133.296.236-.096 59.232-.2.252-68.295-33.178z",
    fill: "#7a3e65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m208.752 204.456-80.64 19.312-40.488-9.773-27.919 4.976 68.295 19.907 105.405-28.537 1.118-2.18z",
    fill: "#cfb2c1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m196.295 79.626-.657-.749-66.904-19.44-.734.283-.672-.343-105.276 30.357-.575.703.845.463 24.075 3.53.851-.289 80.64-19.311 40.488 9.773z",
    fill: "#512843"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m47.248 240.537-25.771 6.221-.045-.149-1.015-155.026 1.06-1.146 25.771 3.704z",
    fill: "#c17b9e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m82.04 180.403 45.96 5.391.345-.515.187-71.887-.532-.589-45.96 5.392z",
    fill: "#7a3e65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m173.96 180.403-45.96 5.391v-72.991l45.96 5.392z",
    fill: "#c17b9e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m196.295 79.626-68.295-19.906v-59.72l68.295 33.177z",
    fill: "#c17b9e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m128 0-128 61.793v175.011l21.477 9.954v-156.321l106.523-30.717z",
    fill: "#7a3e65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m234.523 51.425v156.736l-106.523 30.717v59.72l128-61.794v-175.011z",
    fill: "#c17b9e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCognito);
export default __webpack_public_path__ + "static/media/aws-cognito.b5b6b8a0c58cf53e500e7dfa8cbb19ad.svg";
export { ForwardRef as ReactComponent };